const mergeThemes = (defaultTheme, themeOverrides, providerTheme, transform) => ({
  ...defaultTheme,
  ...transform ? transform(providerTheme) : providerTheme,
  ...themeOverrides
});

export { mergeThemes };
